import { render } from "./AppWrapper.vue?vue&type=template&id=bf26ffae"
const script = {}

import exportComponent from "/Users/criscue/Desktop/Proyects/TecbaCocha/team-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__